import { Component, SecurityContext, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, Platform, ModalController, Slides, MenuController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { DomSanitizer } from '@angular/platform-browser';
//Providers
import { UtilProvider } from '../../providers/util-provider';
import { AuthProvider } from '../../providers/auth-provider';
import { ConfigProvider } from '../../providers/config-provider';
import { ExpositorProvider } from '../../providers/expositor-provider';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
//Pages
import { ExpositorArquivosPage } from './../expositor-arquivos/expositor-arquivos';
import { ExpositorVideoPage } from '../expositor-video/expositor-video';
import { AtividadePage } from '../atividade/atividade';
//Models
import { User } from '../../models/user.model';
import { Expositor } from '../../models/expositor/expositor.model';
import { Mural } from '../../models/expositor/mural.model';
import { Congresso } from '../../models/congresso.model';

@Component({
  selector: 'page-expositor',
  templateUrl: 'expositor.html'
})
export class ExpositorPage {
  
  @ViewChild(Slides) slides: Slides;
  @ViewChild('scrollContent') scrollContent: ElementRef;

  public loaded: boolean;
  public expositor: Expositor;
  public user: User;  
  public isCurrent: boolean = true;

  private usuarioPermitido: boolean = false;
  private congresso: Congresso;

  constructor(
    public navCtrl: NavController, 
    public menuCtrl: MenuController,
    public navParams: NavParams,
    public expositorProvider: ExpositorProvider,
    public utilProvider: UtilProvider,
    public configProvider: ConfigProvider,
    public authProvider: AuthProvider,
    private iab: InAppBrowser,
    private sanitizer: DomSanitizer,
    private platform: Platform,
    private modalCtrl: ModalController,
    private alert: CustomAlert) {
    this.user = JSON.parse(localStorage.getItem('user')) as User;
    this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
    
  }

  ionViewDidEnter(){
    this.menuCtrl.swipeEnable(false, 'right');
  }

  ionViewDidLoad() {
    this.get();
  }
    
  get() {
    let self = this;
    let param = self.navParams.get("expositor");
    
    if (self.utilProvider.isConnected(true)) {
      setTimeout(() => {

        var userGuid = this.user ? this.user.Guid : '';

        this.expositorProvider.getExpositorById(param.Id, false, userGuid)
          .then(res => {

            self.expositor = res;
            self.expositor.Logo = this.configProvider.url.Cientifico + self.expositor.Logo;
            self.expositor.ListLogo = this.configProvider.url.Cientifico + self.expositor.ListLogo
            self.expositor.Emblema = this.configProvider.url.Cientifico + self.expositor.Emblema;

            this.isCurrent = this.expositor.CongressoAno == this.configProvider.ANO_ATUAL || this.congresso.Liberado;

            if (self.expositor.Stand) {
              self.expositor.Stand.ImagemHeaderSafe = self.sanitizer.bypassSecurityTrustStyle('url('+ self.configProvider.url.Cientifico + self.expositor.Stand.ImagemHeader + ')');
              self.expositor.Stand.Murais.forEach(x=> {
                x.ImageSafe = this.sanitizer.sanitize(SecurityContext.URL, self.configProvider.url.Cientifico + x.Image);
              });
            }

            self.loaded = true;

            setTimeout(() => {
              self.checkStandSize();
            }, 300);            

            self.setLocalStorage();
          })
          .catch(response => {
            let err = response;
            if (err) {
              self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
            }
          });
      }, 0);
    }
    else {
      self.getFromStorage();
    }
  }
  
  goto(m: Mural) {
    
    let self = this;
      
    let scrolling = document.getElementById("scrollTable").className == 'draggingTable';
    if (!scrolling) {
      if (m.Video) {

        self.checkLoggedUser();

        if (!self.authProvider.isAuthorized(true)) {
          self.authProvider.isAuthorized();
        }
        else if (!self.usuarioPermitido) {
          self.alert.showAlert('Aviso', 'Conteúdo disponível apenas para inscritos no congresso ' + self.congresso.Ano + '.');
        }
        else if (m.Prescritor && !self.user.Prescritor) {
          self.alert.showAlert('Aviso', 'Vídeo disponível apenas para prescritores.');
        }
        else {
          self.openVideo(m)
        }
      }
      else if (m.RedirectPageName) {
        self.goToPage(m.RedirectPageName, m.RedirectParamValue)
      }
    }  
  }
  
  openVideo(m: Mural) {

    let self = this;

    if (m.Video && self.utilProvider.isConnected(true)) {

      let modal = this.modalCtrl.create(ExpositorVideoPage, {
        id: m.Id,
        urlVideo: m.Video,
        titleVideo: m.Text,
        titlePage: self.expositor.Nome
      });
      modal.present();
    }
  }

  goToPage(page: string, param: string) {
    page = page.toLocaleLowerCase()
    if (page == 'atividade' && param) {
      this.navCtrl.push(AtividadePage, { id: param })
    }
  }

  setLocalStorage() {
    let expositor = this.expositor;
    let itemName = `expositor-${expositor.Id}`;
    localStorage.setItem(itemName, expositor ? JSON.stringify(expositor) : '');
  }

  getFromStorage() {
    let self = this;
    let expositor = self.expositor;
    let itemName = `expositor-${expositor.Id}`;

    if (localStorage.getItem(itemName)) {
      self.expositor = JSON.parse(localStorage.getItem(itemName)).sort(function (a, b) {
        return a.Tipo.localeCompare(b.Tipo);
      });

      self.loaded = true;
    }
  }

  back() {
    this.navCtrl.pop();
  }

  openUrl(url, inNativeBrowser) {
    if (this.utilProvider.isNullOrEmpty(url) || url == '#') {
        return false;
    }
    if (inNativeBrowser) {
        const browser = this.iab.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
        browser.show();
    } else {
        const browser = this.iab.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
        browser.show();
    }
  }

  showModalFiles() {
    let self = this;
    let modal = this.modalCtrl.create(ExpositorArquivosPage, {
      expositor: self.expositor
    });
    modal.present();
  }

  openPesquisa(e: Expositor) {

    let self = this;

    if (self.getValidPequisa(e)) {
      self.openUrl(e.LinkPesquisa, false);
    }
    else if (!self.authProvider.isAuthorized(true)) {
      self.authProvider.isAuthorized();
    }
    else if (!self.usuarioPermitido) {
      self.alert.showAlert('Aviso', 'Pesquisa disponível apenas para inscritos no congresso ' + self.congresso.Ano + '.');
    }
    else {
      this.alert.showAlert('Aviso', 'Pesquisa disponível apenas para prescritores.');
    }
  }

  openSorteio(e: Expositor) {

    let self = this;

    if (this.getValidSorteio(e)) {
      this.openUrl(e.LinkSorteio, false);
    }
    else if (!self.authProvider.isAuthorized(true)) {
      self.authProvider.isAuthorized();
    }
    else if (!self.usuarioPermitido) {
      self.alert.showAlert('Aviso', 'Sorteio disponível apenas para inscritos no congresso ' + self.congresso.Ano + '.');
    }
    else {
      var categories = e.CategoriasSorteio.map(x => x.Description).toString().replace(/,/g, ', ');
      self.alert.showAlert('Aviso', 'Sorteio disponível para membros da(s) categoria(s) <b>' + categories + '</b>.');    
    }
  }

  getValidPequisa(e: Expositor) {
    var self = this;
    var haspesquisa = e.LinkPesquisa

    self.checkLoggedUser();

    return self.authProvider.isAuthorized(true) && self.usuarioPermitido && !!haspesquisa && (!e.PrescritorPesquisa || (e.PrescritorPesquisa && self.user.Prescritor));
  }

  getValidSorteio(e: Expositor) {
    var self = this;
    var haslink = e.LinkSorteio;
    var hasCategories = e.CategoriasSorteio.length > 0;
    
    self.checkLoggedUser();

    //logado
    if (hasCategories && !!haslink && this.authProvider.isAuthorized(true) && self.user) {
      return e.CategoriasSorteio.some(x => x.CategoryId == self.user.CategoriaId && self.user.TipoAssociacaoId == x.TipoAssociacaoId);
    }

    return this.authProvider.isAuthorized(true) && self.usuarioPermitido && !!haslink && !hasCategories;
  }

  openContato(e: Expositor) {

      let self = this;

      if (!self.authProvider.isAuthorized(true)) {
        self.authProvider.isAuthorized();
      }
      else if (!self.usuarioPermitido) {
        self.alert.showAlert('Aviso', 'Contato disponível apenas para inscritos no congresso ' + self.congresso.Ano + '.');
      }
      else {
        self.openUrl(e.LinkContato, false);
      }
  }

  checkLoggedUser() {
    let self = this;
    if (self.authProvider.isAuthorized(true) && !self.user) {
      self.user = JSON.parse(localStorage.getItem('user')) as User;      
    }
    else if (!self.authProvider.isAuthorized(true) && self.user) {
      self.user = undefined;
      self.usuarioPermitido = false;
    }
    
    self.usuarioPermitido = self.user && self.user.InscricaoPaga;
  }

  isIPhoneOrAndroid() {
    return this.platform.is('iphone') || this.platform.is('ipad') || this.platform.is('android');
  }

  isMobile() {
    return this.isIPhoneOrAndroid() || !this.isIPhoneOrAndroid() && this.utilProvider.isPhone()
  }

  checkStandSize() {
    let self = this;
    let platformWidth = self.platform.width();
    let scrollTable = document.getElementById("scrollTable");
    let scrollWidth = scrollTable ? scrollTable.offsetWidth : 0;
    let headerStand = document.getElementById("headerStand")
    let footerStand = document.getElementById("footerStand");
    let footerStandMobile = document.getElementById("footerStandMobile");

    if (!self.isIPhoneOrAndroid() && scrollTable && scrollWidth > platformWidth) {
      self.dragElement(scrollTable, platformWidth, scrollWidth, scrollTable);
      headerStand.style.width = platformWidth + 'px';
      scrollTable.style.left = '0';
      scrollTable.style.position = 'absolute';

      if (footerStand)
        footerStand.style.marginTop = scrollTable.offsetHeight + 'px';      
      else
        footerStandMobile.style.marginTop = scrollTable.offsetHeight + 'px';      
    }
    else {

      if (headerStand) {
        headerStand.style.width = 10 + 'px';
      }

      let scrollContent = document.getElementById("scrollContent");
      if (scrollContent  && scrollWidth > platformWidth) {
        scrollContent.style.overflowX = "scroll";
      }
    }
  }


  // Drag Stand
  dragElement(elmnt, dWidth, sWidth, sTable) {
      var pos1 = 0, pos2 = 0;
      var displayWidth = dWidth;
      var scrollWidth = sWidth;
      var scrollTable = sTable;

      if (document.getElementById(elmnt.id)) {
        // if present, the header is where you move the DIV from:
        document.getElementById(elmnt.id).onmousedown = dragMouseDown;
      } else {
        // otherwise, move the DIV from anywhere inside the DIV:
      elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos2 = e.clientX;
      //pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos2 - e.clientX;
      pos2 = e.clientX;

      // set the element's new position:      
      let extraSpace = 10
      let position = (elmnt.offsetLeft - pos1);
      let positionLeft = 0 + extraSpace;
      let positionRight = displayWidth - scrollWidth - extraSpace - extraSpace;

      if (position <= positionLeft && position >= positionRight) {
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
      }

      if (scrollTable.className != 'draggingTable') {
        scrollTable.className = 'draggingTable';
        setTimeout(() => {
          scrollTable.className = '';
        }, 300);
      }
      
    }

    function closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/expositor/expositor.ts